import React, { FC } from 'react';
import styles from './WidthLimiter.module.scss';

interface IWidthLimiterProps {
    width?: number;
    children: React.ReactNode;
}

const WidthLimiter: FC<IWidthLimiterProps> = ({ width, children }) => {
    return (
        <div className={styles.container} style={{ width: width }}>
            {children}
        </div>
    );
};

export default WidthLimiter;
